import React from "react";
import { TextInput } from "react-admin";

/**
 * ErrorBoundary que evita pantalla blanca cuando un input frágil
 * (ej: RichTextInput/Quill) revienta al montarse en una pestaña.
 * Degrada a un TextInput multilínea para no perder la edición.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary capturó un error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      const fallback = this.props.fallback;
      if (fallback) return fallback;
      return (
        <p style={{ color: "#c62828" }}>
          Error al renderizar este campo. Recargá la página para reintentar.
        </p>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;

// Fallback listo para RichTextInput: campo de texto plano con el mismo source.
export const richTextFallback = (source, label) => (
  <TextInput source={source} label={label} multiline fullWidth />
);